import { render, staticRenderFns } from "./FractionInput.vue?vue&type=template&id=a6549050&scoped=true"
import script from "./FractionInput.vue?vue&type=script&lang=js"
export * from "./FractionInput.vue?vue&type=script&lang=js"
import style0 from "./FractionInput.vue?vue&type=style&index=0&id=a6549050&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6549050",
  null
  
)

export default component.exports